'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentAdvisory = require('./ContentAdvisory');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentAdvisory).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/ContentAdvisory/index.js
// module id = 167
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14